import React from 'react';
import styles from './StudyMenu.module.css';
import FavoriteBooksView from './FavoriteBooksView';

const StudyMenu = ({
  cardConfigs,
  onSelectView,
  favoriteBookPreviews = [],
  favoriteWordPreviewGroups = [],
  favoriteSentencePreviewGroups = [],
  favoriteNotePreviewGroups = [],
  bookMetadata = {},
  completedChapterCounts = {},
  bookMetadataLoading,
  bookMetadataError,
  onOpenBookDetail,
  onDeleteBook,
  onOpenBookWords,
  sentenceExpandedState = {},
  onToggleSentenceGroup,
  onPlayClip,
  onStopClip,
  playingClip,
  onDeleteSentence,
  onStartSentenceStudy,
  sentenceLoading,
  sentenceError,
  noteExpandedState = {},
  onToggleNoteGroup,
  onDeleteNote,
  onStartNoteStudy,
  noteLoading,
  noteError,
}) => {
  const iconColorClassMap = {
    books: styles.iconBlue,
    words: styles.iconAmber,
    sentences: styles.iconGreen,
    notes: styles.iconPurple,
  };

  const booksCard = cardConfigs.find((card) => card.key === 'books');
  const handleViewAllBooks = () => {
    if (onSelectView) {
      onSelectView(booksCard || { key: 'books', title: '书籍' });
    }
  };
  const wordsCard = cardConfigs.find((card) => card.key === 'words');
  const handleViewAllWords = () => {
    if (onSelectView) {
      onSelectView(wordsCard || { key: 'words', title: '单词' });
    }
  };
  const sentencesCard = cardConfigs.find((card) => card.key === 'sentences');
  const handleViewAllSentences = () => {
    if (onSelectView) {
      onSelectView(sentencesCard || { key: 'sentences', title: '句子' });
    }
  };
  const notesCard = cardConfigs.find((card) => card.key === 'notes');
  const handleViewAllNotes = () => {
    if (onSelectView) {
      onSelectView(notesCard || { key: 'notes', title: '学习笔记' });
    }
  };

  return (
    <div className={styles.menuView}>
      <div className={styles.cardGrid}>
        {cardConfigs.map((card) => (
          <button
            key={card.key}
            type="button"
            className={styles.menuCard}
            onClick={() => onSelectView(card)}
            aria-label={`查看${card.title}`}
          >
            <div
              className={`${styles.menuCardIcon} ${
                iconColorClassMap[card.key] || styles.iconDefault
              }`}
            >
              {card.icon}
            </div>
            <div className={styles.menuCardTitle}>{card.title}</div>
            <div className={styles.menuCardCount}>{card.count}</div>
          </button>
        ))}
      </div>

      {favoriteBookPreviews.length > 0 && (
        <div className={styles.previewSection}>
          <div className={styles.menuHeader}>
            <div className={styles.sectionTitleWrapper}>
              <span className={`material-symbols-rounded ${styles.sectionTitleIcon}`} aria-hidden="true">
                library_books
              </span>
              <p className={styles.previewLabel}>收藏书籍</p>
            </div>
            <button
              type="button"
              className={styles.sentencesLink}
              onClick={handleViewAllBooks}
            >
              查看全部
            </button>
          </div>

          <div className={styles.previewList}>
            <FavoriteBooksView
              books={favoriteBookPreviews}
              bookMetadata={bookMetadata}
              completedChapterCounts={completedChapterCounts}
              loading={bookMetadataLoading}
              error={bookMetadataError}
              onDeleteBook={onDeleteBook}
              onOpenBookDetail={onOpenBookDetail}
            />
          </div>
        </div>
      )}

      {favoriteWordPreviewGroups.length > 0 && (
        <div className={styles.previewSection}>
          <div className={styles.menuHeader}>
            <div className={styles.sectionTitleWrapper}>
              <span className={`material-symbols-rounded ${styles.sectionTitleIcon}`} aria-hidden="true">
                translate
              </span>
              <h2 className={styles.sentencesTitle}>收藏单词</h2>
            </div>
            <button
              type="button"
              className={styles.sentencesLink}
              onClick={handleViewAllWords}
            >
              查看全部
            </button>
          </div>

          <div className={styles.wordsList}>
            {favoriteWordPreviewGroups.map((group) => (
              <div
                key={group.key}
                className={styles.wordItem}
                role="button"
                tabIndex={0}
                onClick={() => onOpenBookWords?.(group)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onOpenBookWords?.(group);
                  }
                }}
              >
                <div className={styles.wordItemLeft}>
                  {/* <span className={`material-icons-round ${styles.sentencesRowIcon}`}>
                    translate
                  </span> */}
                  <span className={styles.wordItemTitle}>{group.bookTitle}</span>
                </div>
                <div className={styles.wordItemRight}>
                  <span className={styles.wordItemCount}>{group.itemCount}</span>
                  <span className={`material-icons-round ${styles.wordItemArrow}`}>
                    arrow_forward
                  </span>
                </div>
              </div>
            ))}
          </div>
          </div>
      )}

      {favoriteSentencePreviewGroups.length > 0 && (
        <div className={styles.previewSection}>
          <div className={styles.menuHeader}>
            <div className={styles.sectionTitleWrapper}>
              <span className={`material-symbols-rounded ${styles.sectionTitleIcon}`} aria-hidden="true">
                format_quote
              </span>
              <h2 className={styles.sentencesTitle}>收藏句子</h2>
            </div>
            <button
              type="button"
              className={styles.sentencesLink}
              onClick={handleViewAllSentences}
            >
              查看全部
            </button>
          </div>

          <div className={styles.sentencesCard}>
            <div className={styles.sentencesList}>
              {favoriteSentencePreviewGroups.map((group) => (
                <div key={group.key} className={styles.sentencesRow}>
                  <div className={styles.sentencesRowLeft}>
                  
                    <span className={styles.sentencesRowTitle}>{group.bookTitle}</span>
                  </div>
                  <div className={styles.sentencesRowRight}>
                    <span className={styles.sentencesRowCount}>{group.itemCount} sentences</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {favoriteNotePreviewGroups.length > 0 && (
        <div className={styles.previewSection}>
          <div className={styles.menuHeader}>
            <div className={styles.sectionTitleWrapper}>
              <span className={`material-symbols-rounded ${styles.sectionTitleIcon}`} aria-hidden="true">
                edit_note
              </span>
              <h2 className={styles.sentencesTitle}>学习笔记</h2>
            </div>
            <button
              type="button"
              className={styles.sentencesLink}
              onClick={handleViewAllNotes}
            >
              查看全部
            </button>
          </div>

          <div className={styles.sentencesCard}>
            <div className={styles.sentencesList}>
              {favoriteNotePreviewGroups.map((group) => (
                <div key={group.key} className={styles.sentencesRow}>
                  <div className={styles.sentencesRowLeft}>
           
                    <span className={styles.sentencesRowTitle}>{group.bookTitle}</span>
                  </div>
                  <div className={styles.sentencesRowRight}>
                    <span className={styles.sentencesRowCount}>{group.itemCount} notes</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudyMenu;
